import React from 'react'
import DocumentHead from '../components/DocumentHead'
import MarketingNav from '../components/marketing/MarketingNav'
import HeroSection from '../components/marketing/HeroSection'
import ParcoursSection from '../components/marketing/ParcoursSection'
import ChangeSection from '../components/marketing/ChangeSection'
import ReportSection from '../components/marketing/ReportSection'
import ParticipationSection from '../components/marketing/ParticipationSection'
import TrustSection from '../components/marketing/TrustSection'
import CtaSection from '../components/marketing/CtaSection'
import FooterSection from '../components/marketing/FooterSection'

const HomePage: React.FC = () => {
  return (
    <div className="min-h-screen bg-surface">
      <DocumentHead titleId="marketing.meta.title" descriptionId="marketing.meta.description" />
      <MarketingNav />
      <HeroSection />
      <ParcoursSection />
      <ChangeSection />
      <ReportSection />
      <ParticipationSection />
      <TrustSection />
      <CtaSection />
      <FooterSection />
    </div>
  )
}

export default HomePage
